module.exports = __webpack_public_path__ + "img/step3.2b8efae7.png";